var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255.1 255.1",
    style: {
      enableBackground: "new 0 0 255.1 255.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5A8EA2;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 127.6,
    cy: 127.6,
    r: 121.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.336,127.584c-0.022-0.038-0.022-0.085,0-0.123l41.883-71.558c0.022-0.037,0.062-0.059,0.104-0.059h83.013 c0.044,0,0.083,0.022,0.106,0.061l41.423,71.558c0.021,0.037,0.021,0.085,0,0.122l-41.423,71.479 c-0.022,0.037-0.062,0.061-0.106,0.061H86.323c-0.044,0-0.083-0.022-0.104-0.059L44.336,127.584z M166.187,127.482 c0,21.304-17.27,38.574-38.574,38.574s-38.574-17.27-38.574-38.574s17.27-38.574,38.574-38.574S166.187,106.178,166.187,127.482z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteel);
export default __webpack_public_path__ + "static/media/steel.08f9721fcbbf7cd706635ea51da9bc7c.svg";
export { ForwardRef as ReactComponent };